import React, { useState } from "react";
import cn from "classnames";

import styles from "./CompanyLogoOutlined.module.scss";

interface CompanyLogoOutlinedProps {
    companyUrl?: string;
    className?: string;
    logoUrl: string;
    altText: string;
    extraLinkProps?: {[x: string]: any};
}

const CompanyLogoOutlined = (props: CompanyLogoOutlinedProps) => {
    const {
        altText, companyUrl, logoUrl, className, extraLinkProps
    } = props;
    const [image404, setImage404] = useState(false);

    const disableFocusClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.currentTarget.blur();
        event.stopPropagation();
    };

    const image404Callback = () => {
        setImage404(true);
    };

    const Pill = () => (image404 ? <>Company Logo</> : (
        <img
            onError={image404Callback}
            alt={altText}
            height="48"
            loading="lazy"
            src={logoUrl}
            width="108"
            {...extraLinkProps}
        />
    ));

    const classNames = cn(
        companyUrl ? styles.pillLink : styles.logoPill, className,
        image404 ? styles.image404 : ""
    );
    return companyUrl ? (
        <a className={classNames} href={companyUrl} onMouseUp={disableFocusClick} {...extraLinkProps}>
            <Pill />
        </a>
    ) : (
        <div className={classNames}>
            <Pill />
        </div>
    );
};

export { CompanyLogoOutlined as default };
export type { CompanyLogoOutlinedProps };
